import { NotFoundPage } from "@humanex/ui/components";
import { REF_CODE_SEARCH_PARAM } from "@humanex/ui/libs";
import { Outlet, createRootRoute, useNavigate, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

import { useReferralCodeHandler } from "@/hooks/referral-handler";
import { useAuthStore } from "@/stores/auth.store";

import { LoadingPage } from "../components/loading.page";

export const Route = createRootRoute({
  component: () => Root(),
  notFoundComponent: () => <NotFoundPage homeHref="/" />,
  validateSearch: (search) => {
    const ref = search[REF_CODE_SEARCH_PARAM] as string;
    if (ref) {
      return { ref };
    } else {
      return {};
    }
  }
});

// Routes that don't need sidebar/auth guard
const AUTH_PATHS = ["/"];

function Root() {
  const navigate = useNavigate();
  const router = useRouter();
  const { loggedIn, loading } = useAuthStore();
  const currentPath = router.state.location.pathname;

  const { ref } = Route.useSearch();
  useReferralCodeHandler(ref);

  const isAuthPath = AUTH_PATHS.includes(currentPath);

  // Auth guard
  useEffect(() => {
    if (loading) return;
    else if (!loggedIn && !isAuthPath) navigate({ to: "/" });
    else if (loggedIn && isAuthPath) navigate({ to: "/home" });
  }, [loading, loggedIn, isAuthPath, navigate]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="relative min-h-screen max-w-screen">
      <div className="bg-primary-50 fixed inset-0 z-[-1]" />
      <div className="relative flex flex-col h-screen w-full">
        <Outlet />
      </div>
    </div>
  );
}
